import { render, staticRenderFns } from "./GetQuestion.vue?vue&type=template&id=08d7ba1a"
import script from "./GetQuestion.vue?vue&type=script&lang=js"
export * from "./GetQuestion.vue?vue&type=script&lang=js"
import style0 from "./GetQuestion.vue?vue&type=style&index=0&id=08d7ba1a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports